<template>
  <v-dialog
    :model-value="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    width="500px"
    persistent
  >
    <v-card class="pa-5" cxolor="grey-lighten-1">
      <v-card-title class="teal-darken-3 px-0">Actualizar Stock</v-card-title>
      <v-card-subtitle class="px-0 mb-4">
        {{ etiqueta.name }}
      </v-card-subtitle>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="etiqueta.quantity"
            ref="quantityInput"
            class="teal-darken-3"
            label="Cantidad actual"
            @input="etiqueta.quantity = Number(soloNumeros(String(etiqueta.quantity)))"
            @keyup.enter="actualizar"
            variant="outlined"
            require
          />
        </v-col>
      </v-row>
      <v-card-actions class="px-5 pb-4">
        <v-btn
          color="teal-darken-3"
          variant="flat"
          class="text-grey-lighten-1"
          @click="actualizar"
        >
          Agregar
        </v-btn>
        <v-spacer />
        <v-btn
          variant="outlined"
          color="teal-darken-3"
          @click="$emit('update:modelValue', false)"
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps, nextTick, ref, watch, defineEmits, reactive } from "vue";

const props = defineProps({
  modelValue: Boolean,
  stockToUpdate: Object,
});

const emit = defineEmits(["update:modelValue", "alert", "created"]);

const quantityInput = ref(null);

const etiqueta = reactive({
  _id: null,
  name: "",
  quantity: 0,
});

watch(
  () => props.modelValue,
  async (val) => {
    if (val && props.stockToUpdate) {
      etiqueta._id = props.stockToUpdate._id;
      etiqueta.name = props.stockToUpdate.name;
      etiqueta.quantity = props.stockToUpdate.quantity;

      await nextTick();
      if (quantityInput.value) {
        quantityInput.value.focus();
      }
    }
  }
);

const actualizar = () => {
  if (etiqueta.quantity < 0) {
    emit("alert", "La cantidad no puede ser negativa");
    return;
  }
  emit("created", { ...etiqueta });
};

const soloNumeros = (valor) => {
  return valor.replace(/\D/g, "");
};
</script>

<style scoped>
.teal-darken-3 {
  color: #00695c;
}
</style>
